import { merge } from "lodash.merge";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

import {
  mapApiDataToReferenceData,
  mapApiDataToSponsorDetails,
} from "../utils/helpers/genericReferenceData.helper";

export const useGenericReferenceDataStore = createWithEqualityFn(
  devtools(
    persist(
      (set, get) => ({
        data: {
          esg: [],
          taxState: [],
          fundingSource: [],
          statePreference: [],
          yearsToTransition: [],
          categories: [],
          strategies: {},
          strategyDetails: [],
          sessionProposals: [],
          state: [],
          sector: [],
        },
        actions: {
          setGenericReferenceData: (data) => {
            const referenceData = mapApiDataToReferenceData(data);
            set((s) => ({
              data: {
                ...s.data,
                ...referenceData,
              },
            }));
            return referenceData;
          },
          setSponsorDetails: (data) => {
            const sponsorDetails = mapApiDataToSponsorDetails(data);
            set((s) => ({
              data: {
                ...s.data,
                ...sponsorDetails,
              },
            }));
            return sponsorDetails;
          },
          setAllGenericReferenceData: ({
            fetchedReferenceData,
            fetchedSponsorDetails,
          }) => {
            const genericReferenceData = {
              ...mapApiDataToReferenceData(fetchedReferenceData),
              ...mapApiDataToSponsorDetails(fetchedSponsorDetails),
            };
            set((s) => ({
              data: {
                ...s.data,
                ...genericReferenceData,
              },
            }));
            return genericReferenceData;
          },
        },
      }),
      {
        name: "generic-reference-data",
        storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used,
        merge: (persistedState, currentState) =>
          merge(persistedState, currentState),
      }
    )
  )
);
